import { Component, OnInit } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { UnsubscribableComponent } from '@app/shared/unsubscribable/unsubscribable.component';
import { InlineAssessmentService } from '../inline-assessment.service';
import * as feather from 'feather-icons';

@Component({
  standalone: false,
  selector: 'app-inline-assessment',
  templateUrl: './inline-assessment.component.html',
  styleUrls: ['./inline-assessment.component.css'],
})
export class InlineAssessmentComponent extends UnsubscribableComponent implements OnInit {
  public biometricIdentifiedData: Partial<any> = {};
  public initialState: any = {
    firstName: '',
    lastName: '',
    address: '',
    country: '',
    phone: '',
    email: '',
    ssn: '',
    dob: '',
    biometricIdentifier: '',
    requestId: '',
  };

  public appliedAttributes: any = null;
  public screeningResponse: any[] = [];
  public error: string;

  data: any[] = [];
  pagedData: any[] = [];
  searchTerm = '';
  isLoading = false;
  currentPage=1;
  totalPages=0;
  totalItems=0;
  pageSize=25;
  enable=false

  constructor(
    private _inlineassessment: InlineAssessmentService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this._initializeStateFromParams();
    this.loadData();
  }
  ngAfterViewInit() {
    feather.replace();
  }
  loadData(): void {
    this.isLoading = true;
    this._inlineassessment
      .inlineassessmentService(this.enable)
      .pipe(
        catchError((error) => {
          this.error = 'Failed to fetch data. Please try again later.';
          this.isLoading = false;
          return throwError(error);
        }),
      )
      .subscribe(
        (response: any) => {
          this.data = response.data.sort((a, b) => a.id - b.id);
          this.totalItems = this.data.length;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.filterData();
          this.isLoading = false;
        },
        () => {
          this.error = 'Failed to fetch data. Please try again later.';
          this.isLoading = false;
        },
      );
  }

  filterData(): void {
    if (this.searchTerm) {
      this.pagedData = this.data.filter(
        (item) =>
          (item.id && item.id.toString().includes(this.searchTerm)) ||
          (item.payload.candidate
            ? `${item.payload.candidate.firstName} ${item.payload.candidate.lastName}`
                .toLowerCase()
                .includes(this.searchTerm.toLowerCase())
            : '') ||
            item.payload.candidate.email.toLowerCase().includes(this.searchTerm)
      );
    } else {
      this.pagedData = [...this.data];
    }
  }
  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.filterData();
    }
  }
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.filterData();
    }
  }
  goToFirstPage(): void {
    this.currentPage = 1;
    this.filterData();
  }

  goToLastPage(): void {
    this.currentPage = this.totalPages;
    this.filterData();
  }
  
  onBiometricIdentification(item: any) {
    const matrixParams = {
      name: String(
        `${
          (item.payload.candidate ? item.payload.candidate.firstName : '') +
          (item.payload.candidate ? item.payload.candidate.lastName : '')
        }`,
      ),
      recordId: item.id,
    };
    this._router.navigate(['/home/biometric-identity', { ...matrixParams }]);
  }

  private _initializeStateFromParams(): void {
    const paramsMap = this._activatedRoute.snapshot.paramMap;
    const initialStateKeys = Object.keys(this.initialState);
    const dataFromParams: Partial<any> = {};

    paramsMap.keys
      .filter((key) => initialStateKeys.includes(key))
      .forEach((key) => {
        dataFromParams[key] = paramsMap.get(key);
      });

    this.initialState = Object.assign({ ...this.initialState }, dataFromParams);
  }

  public onviewResponseClick(item: any): void {
    const matrixParams = {
      name: String(
        `${
          (item.payload.candidate ? item.payload.candidate.firstName : '') +
          ' ' +
          (item.payload.candidate ? item.payload.candidate.lastName : '')
        }`,
      ),
      recordId: item.id,
    };
    this._router.navigate([`home/assessment-investigation`, { ...matrixParams }]);
  }

  public reset(): void {
    this.searchTerm = ''; 
    this.filterData(); 
  }
  isEnable() {
    this.enable = !this.enable
    this.loadData()
  }
}
